import Service from "../../service/index";


const Police = {
    namespaced: true,
    state: {
        police_station: [],
        police_station_for_hospital :[]
    },
    mutations: {
        GET_POLICE: (state, data) => {
            state.police_station = data;
        },
        GET_POLICE_FOR_HOSPITAL: (state, data) => {
            if (data.length >0){
              state.police_station_for_hospital = data;
            }else {
              state.police_station_for_hospital =null;
            }
        },

    },
    actions: {
        setPolice({commit}){
            return Service.Police.getPolice()
                .then(data=>{
                    commit("GET_POLICE",data);
                })
        },
        setPoliceForHospital({commit},hospital_code){
            return Service.Police.getPoliceByHospital(hospital_code)
                .then(data=>{
                    commit("GET_POLICE_FOR_HOSPITAL",data);
                })
        },
        setPoliceByProvince({commit},province_code){
            return Service.Police.getPoliceByProvince(province_code)
                .then(data=>{
                    commit("GET_POLICE_FOR_HOSPITAL",data);
                    return data;
                })
        },
        onGetListPoliceStation({commit},hospital_code){
            return Service.Police.getListPoliceStation(hospital_code)
                .then(data=>{
                    commit("GET_POLICE_FOR_HOSPITAL",data);
                    return data;
                })
        },
        onDeletePoliceStation({commit},data){
            return Service.Police.deletePoliceStation(data)
                .then(data=>{
                    commit("GET_POLICE_FOR_HOSPITAL",data);
                    return data;
                })
        },
        onGetPoliceStationOption({commit},hospital_code){
            return Service.Police.getPoliceStationOption(hospital_code)
                .then(data=>{
                    commit("GET_POLICE_FOR_HOSPITAL",data);
                    return data;
                })
        },
        updatePoliceStation({commit},data){
            return Service.Police.savePoliceStation(data)
                .then(data=>{
                    commit("GET_POLICE_FOR_HOSPITAL",data);
                })
        }
    }
};
export default Police;
